interface TopDomainConfigItem {
  display_name: string,
  jump_url: string
}

export const TopDomainConfigMap: { [key: string]: TopDomainConfigItem } = {
  'duba.net': {
    display_name: 'duba.net',
    jump_url: '//duba.net'
  },
  'zhhainiao.com': {
    display_name: 'ZHHAINIAO.COM',
    jump_url: '//zhhainiao.com/index.html'
  },
  'mingting.cn': {
    display_name: 'mingting.cn',
    jump_url: '//mingting.cn'
  }
}

function getTopDomainConfig () {
  const domainSplit = window.location.hostname.toLowerCase().split('.')
  const topDomain = domainSplit.slice(-2).join('.')
  return TopDomainConfigMap[topDomain] || TopDomainConfigMap['duba.net']
}

export const TOP_DOMAIN_CONFIG = getTopDomainConfig()

